export default __webpack_public_path__ + "static/media/st2.5c4ee6f8.jpg";